import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

//ICONS
import {ReactComponent as Complete} from '../../assets/CompletedStep.svg';
import {ReactComponent as Lock} from '../../assets/Lock.svg';
import {ReactComponent as Delivery} from '../../assets/Delivery.svg';
import {ReactComponent as HandShake} from '../../assets/HandShake.svg';
import {ReactComponent as Wallet} from '../../assets/Wallet.svg';

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    
    align-items: center;
    justify-content: center;
`;

const StepperIcon = styled.div`
    width: 64px;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    
    
    /* default/gray/200 */
    border-radius: 64px;
    background-color: var(--color-gray-200);    
    box-shadow: ${props => ((props.active) ? 'inset 0 0 0 5px var(--color-green-400)' : '0 0 0 0')};
    
    svg, path, svg > * {
      stroke: ${props => ((props.active) ? 'var(--company);' : 'var(--color-gray-600);')};
    }
`;

export const STEPPER_STATE = {
    ACTIVE: 'ACTIVE',
    COMPLETED: 'COMPLETED',
    IN_ACTIVE: 'IN_ACTIVE',
};

// const steps = [
//     {
//         icon: <HandShake/>,
//         state: STEPPER_STATE.COMPLETED,
//         label: 'Contract Signed'
//     },
//     {
//         icon: <Delivery/>,
//         state: STEPPER_STATE.ACTIVE,
//         label: 'Device Delivery'
//     },
//     {
//         icon: <Lock/>,
//         state: STEPPER_STATE.COMPLETED,
//         label: 'Policies Added'
//     },
//     {
//         icon: <Wallet/>,
//         state: STEPPER_STATE.IN_ACTIVE,
//         label: 'Contract Payments'
//     }
// ];

function ContractStepper({steps, status, ...props}) {
    return (
        <Wrapper>

            {
                steps.map((item, index) => {
                    const completed = item.state !== STEPPER_STATE.IN_ACTIVE;
                    const showPath = index !== 0;

                    return (
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center'
                        }}
                        >
                            {showPath && <Path style={{marginBottom: '50px'}} active={completed}/>}

                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center'
                            }}
                            >
                                <Step state={item.state} icon={item.icon}/>
                                <Label label={item.label} state={item.state}/>
                            </div>
                        </div>
                    );
                })
            }
        </Wrapper>
    );
}

function Step({icon, state}) {
    switch (state) {
    case STEPPER_STATE.ACTIVE:
        return <StepperIcon active={true}>
            {icon}
        </StepperIcon>;
    case STEPPER_STATE.COMPLETED:
        return <Complete/>;
    case STEPPER_STATE.IN_ACTIVE:
        return <StepperIcon active={false}>
            {icon}
        </StepperIcon>;
    default:
        return null;
    }
}

const Path = ({active}) => (
    <div style={{
        width: '72px',
        marginBottom: '50px',
        /* default/green/300 */
        border: active ? '2px solid #9AE6B4' : 'none',
    }}
    />
);

const Label = ({state, label}) => (
    <div style={{
        width: '51px',
        height: '32px',
        fontSize: '14px',
        lineHeight: '16px',
        textAlign: 'center',
        marginTop: '20px',
        alignSelf: 'center',

        color: state === STEPPER_STATE.COMPLETED ? '#2F855A' : state === STEPPER_STATE.ACTIVE ? '#002A95' : 'var(--color-gray-600)'
    }}
    >
        {label}
    </div>
);

ContractStepper.propTypes = {
    status: PropTypes.string,
    steps: PropTypes.array.isRequired
};
ContractStepper.defaultProps = {};

export default ContractStepper;
